import { cn } from "@/lib/utils";
import { ManualAssistantMessage } from "@/store/zustand/aiContextStore";
import { Loader2 } from "lucide-react";
import React from "react";

export interface CommitProps {
  progressItems?: ManualAssistantMessage["progressItems"];
}

export const ProgressBlock = React.memo(({ progressItems }: CommitProps) => {
  return (
    <div className={cn("flex flex-col grow bg-secondary-200 px-1 rounded-md")}>
      <div className="flex flex-col">
        {progressItems?.map?.((item, index) => {
          const showFailed = item.failed;
          const showSucceeded = item.succeeded;
          const showLoading = item.loading && !item.failed && !item.succeeded;

          return (
            <div
              key={index}
              className="flex flex-row gap-1 items-center justify-start p-2"
            >
              {(showFailed || showSucceeded || showLoading) && (
                <div className={cn(showLoading && "animate-spin")}>
                  {showFailed ? (
                    <img
                      src="/icons/ai-chat-status/failed.svg"
                      className="size-4 shrink-0"
                    />
                  ) : showSucceeded ? (
                    <img
                      src="/icons/ai-chat-status/success.svg"
                      className="size-4 shrink-0"
                    />
                  ) : (
                    <Loader2 className="size-4" />
                  )}
                </div>
              )}

              <div className="rounded-md text-xs bg-secondary-n-950 text-secondary-n-50 break-all">
                {item.title}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
});
